import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike'
import DownhillSkiingIcon from '@mui/icons-material/DownhillSkiing'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PoolIcon from '@mui/icons-material/Pool'
import SnowboardingIcon from '@mui/icons-material/Snowboarding'

import { RELATIONS, SKILL_LEVELS, SPORTS } from '../share/Constant'

export const UNREADY = Symbol('UNREADY')

// Relationship options from OpenAPI spec
export const RELATIONS_OPTIONS = {
  SELF: { value: RELATIONS.SELF, label: '' },
  SPOUSE: { value: RELATIONS.SPOUSE, label: 'Spouse' },
  CHILD: { value: RELATIONS.CHILD, label: 'Child' },
  PARENT: { value: RELATIONS.PARENT, label: 'Parent' },
  OTHER: { value: RELATIONS.OTHER, label: 'Other' },
}

// Sport skill levels from OpenAPI spec
export const SKILL_LEVELS_OPTIONS = {
  NO_EXPERIENCE: { value: SKILL_LEVELS.NO_EXPERIENCE, label: 'No Experience', color: 'default' },
  BEGINNER: { value: SKILL_LEVELS.BEGINNER, label: 'Beginner', color: 'info' },
  INTERMEDIATE: { value: SKILL_LEVELS.INTERMEDIATE, label: 'Intermediate', color: 'success' },
  ADVANCED: { value: SKILL_LEVELS.ADVANCED, label: 'Advanced', color: 'warning' },
}

// Sport types (assuming these match the existing sport types)
export const SPORTS_OPTIONS = {
  SNOWBOARD: { value: SPORTS.SNOWBOARD, label: 'Snowboard', icon: <SnowboardingIcon /> },
  SKI: { value: SPORTS.SKI, label: 'Ski', icon: <DownhillSkiingIcon /> },
  MOUNTAIN_BIKE: { value: SPORTS.MOUNTAIN_BIKE, label: 'Mountain Bike', icon: <DirectionsBikeIcon /> },
  WATER_SPORTS: { value: SPORTS.WATER_SPORTS, label: 'Water Sports', icon: <PoolIcon /> },
  OTHERS: { value: SPORTS.OTHERS, label: 'Others', icon: <MoreHorizIcon /> },
}

export const SKILL_LEVEL_TOOLTIP = {
  SKI: {
    NO_EXPERIENCE: {
      value: SKILL_LEVELS.NO_EXPERIENCE,
      label: 'New to Skiing',
      tooltip: 'A new skier who may have tried once or twice and is still learning the basics — standing up, stopping safely, and making simple turns on gentle slopes.',
    },
    BEGINNER: {
      value: SKILL_LEVELS.BEGINNER,
      label: 'Beginner',
      tooltip: 'A beginner skier can ski on easy green runs, control speed, and make simple turns on groomed terrain.',
    },
    INTERMEDIATE: {
      value: SKILL_LEVELS.INTERMEDIATE,
      label: 'Intermediate',
      tooltip: 'An intermediate skier can handle blue slopes with some control on uneven terrain, managing small bumps or mixed snow with care.',
    },
    ADVANCED: {
      value: SKILL_LEVELS.ADVANCED,
      label: 'Advanced',
      tooltip: 'An advanced skier moves smoothly and confidently on steep or uneven terrain, including moguls, powder, and icy patches.',
    },
  },
  SNOWBOARD: {
    NO_EXPERIENCE: {
      value: SKILL_LEVELS.NO_EXPERIENCE,
      label: 'New to Snowboarding',
      tooltip: 'A new snowboarder who may have tried the sport once or twice and is still learning to balance, slide, and control edges on gentle slopes.',
    },
    BEGINNER: {
      value: SKILL_LEVELS.BEGINNER,
      label: 'Beginner',
      tooltip: 'A beginner snowboard rider can slide and turn on green runs, control speed, and ride comfortably on groomed terrain.',
    },
    INTERMEDIATE: {
      value: SKILL_LEVELS.INTERMEDIATE,
      label: 'Intermediate',
      tooltip: 'An intermediate snowboarder can ride blue runs with some control on uneven snow and bumps, staying balanced through changing terrain.',
    },
    ADVANCED: {
      value: SKILL_LEVELS.ADVANCED,
      label: 'Advanced',
      tooltip: 'An advanced snowboarder rides smoothly and confidently on steep or uneven terrain, such as bumps, powder, and variable snow conditions.',
    },
  },
  MOUNTAIN_BIKE: {
    NO_EXPERIENCE: {
      value: SKILL_LEVELS.NO_EXPERIENCE,
      label: 'New to Mountain Biking',
      tooltip: 'A new mountain biker who may have ridden a few times and is still learning basic bike handling — braking, shifting gears, and staying balanced on simple trails.',
    },
    BEGINNER: {
      value: SKILL_LEVELS.BEGINNER,
      label: 'Beginner',
      tooltip: 'A beginner mountain biker can ride easy trails with groomed surfaces and gentle slopes at a comfortable speed.',
    },
    INTERMEDIATE: {
      value: SKILL_LEVELS.INTERMEDIATE,
      label: 'Intermediate',
      tooltip: 'An intermediate mountain biker can ride moderate trails with some control over uneven terrain like roots, rocks, and small drops.',
    },
    ADVANCED: {
      value: SKILL_LEVELS.ADVANCED,
      label: 'Advanced',
      tooltip: 'An advanced mountain biker rides smoothly and confidently through uneven terrain, handling rocks, drops, and tight turns with control and speed.',
    },
  },
}
